import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { QueryBaseSchema } from '@pkg/api/query/QueryFilterSchema'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { ButtonLink } from '@pkg/ui/button'
import { LinkIndicatorIcon } from '@pkg/ui/common'
import { FormattedNameAndAddress } from '@pkg/ui/formattedContent/NameAndAddress'
import { FaHouseMedicalFlag } from 'react-icons/fa6'
import { z } from 'zod'
import { HospiceSchema } from './schema/Hospice'

const label = t`Hospiz`

export const HospiceConfig = defineEntityConfig(() => ({
  schema: HospiceSchema,

  label,
  labelPlural: t`Hospize`,

  icon: FaHouseMedicalFlag,

  route: {
    list: '/hospize',
    edit: '/hospize/$id',
    new: '/hospize/new',
  },

  relationSelectionColumns: [
    {
      key: 'hospice.name',
      title: label,
      sorter: true,
      render: (_, row) => <FormattedNameAndAddress name={row.name} address={row.address ?? undefined} />,
    },
    {
      title: t`Versorgungsbereich`,
      key: 'hospice.serviceArea',
      sorter: true,
      render: (_, record) => record.serviceArea,
    },
  ],

  indexColumns: [
    {
      key: 'hospice.name',
      title: label,
      fixed: 'start',
      sorter: true,
      render: (_, row) => (
        <FormattedNameAndAddress
          name={row.name}
          address={row.address ?? undefined}
          link={{ to: '/hospize/$id', params: { id: row.id } }}
        />
      ),
    },
    {
      title: t`Versorgungsbereich`,
      key: 'hospice.serviceArea',
      sorter: true,
      render: (_, record) => record.serviceArea,
    },
    {
      key: 'actions',
      title: <Trans>Aktionen</Trans>,
      sorter: false,
      fixed: 'end',
      render: (_, row) => (
        <ButtonLink to="/hospize/$id" params={{ id: row.id }} size="small" shape="round">
          <Trans>Anzeigen</Trans>
          <LinkIndicatorIcon />
        </ButtonLink>
      ),
    },
  ],

  search: {
    filterSchema: QueryBaseSchema.extend({
      sortBy: z.enum(['hospice.name', 'hospice.serviceArea']).nullish(),
    }),
    sortableFields: ['name', 'serviceArea', 'createdAt'] as const,
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => val?.name,
  },
}))
